<ng-container [ngSwitch]="orientation">
  <!-- Horizontal stepper -->
  <div class="n-horizontal-stepper-wrapper" *ngSwitchCase="'horizontal'">
    <div class="n-horizontal-stepper-header-container">
      <ng-container *ngFor="let step of steps; let i = index; let isLast = last">
        <ng-container [ngTemplateOutlet]="stepTemplate" [ngTemplateOutletContext]="{ step: step, i: i }"></ng-container>
        <div *ngIf="!isLast" class="n-stepper-horizontal-line"></div>
      </ng-container>
    </div>

    <div class="n-horizontal-content-container">
      <div
        *ngFor="let step of steps; let i = index"
        class="n-horizontal-stepper-content"
        role="tabpanel"
        [@horizontalStepTransition]="{
          value: _getAnimationDirection(i),
          params: { animationDuration: getAnimationDuration() }
        }"
        (@horizontalStepTransition.done)="_animationDone.next($event)"
        [id]="_getStepContentId(i)"
        [attr.aria-labelledby]="_getStepLabelId(i)"
        [attr.aria-expanded]="selectedIndex === i"
      >
        <ng-container [ngTemplateOutlet]="step.content"></ng-container>
      </div>
    </div>
  </div>

  <!-- Vertical stepper -->
  <ng-container *ngSwitchCase="'vertical'">
    <div
      class="n-step"
      [ngClass]="{ 'n-step-pinned': isStepPinned(i) }"
      *ngFor="let step of steps; let i = index; let isLast = last"
    >
      <ng-container [ngTemplateOutlet]="stepTemplate" [ngTemplateOutletContext]="{ step: step, i: i }"></ng-container>
      <div class="n-vertical-content-container" [class.n-stepper-vertical-line]="!isLast">
        <div
          class="n-vertical-stepper-content"
          role="tabpanel"
          [@verticalStepTransition]="{
            value: _getAnimationDirection(i),
            params: { animationDuration: getAnimationDuration() }
          }"
          (@verticalStepTransition.done)="_animationDone.next($event)"
          [id]="_getStepContentId(i)"
          [attr.aria-labelledby]="_getStepLabelId(i)"
          [attr.aria-expanded]="selectedIndex === i"
        >
          <div class="n-vertical-content py-6">
            <ng-container [ngTemplateOutlet]="step.content"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<!-- Common step templating -->
<ng-template let-step="step" let-i="i" #stepTemplate>
  <n-step-header
    [class.n-horizontal-stepper-header]="orientation === 'horizontal'"
    [class.n-vertical-stepper-header]="orientation === 'vertical'"
    (click)="step.select()"
    (keydown)="_onKeydown($event)"
    [tabIndex]="_getFocusIndex() === i ? 0 : -1"
    [id]="_getStepLabelId(i)"
    [attr.aria-posinset]="i + 1"
    [attr.aria-setsize]="steps.length"
    [attr.aria-controls]="_getStepContentId(i)"
    [attr.aria-selected]="selectedIndex === i"
    [attr.aria-label]="step.ariaLabel || null"
    [attr.aria-labelledby]="!step.ariaLabel && step.ariaLabelledby ? step.ariaLabelledby : null"
    [attr.aria-disabled]="stepIsNavigable(i, step) ? null : true"
    [index]="i"
    [state]="_getIndicatorType(i, step.state)"
    [label]="step.stepLabel || step.label"
    [selected]="selectedIndex === i"
    [active]="stepIsNavigable(i, step)"
    [optional]="step.optional"
    [errorMessage]="step.errorMessage"
  ></n-step-header>
</ng-template>
